module.exports = __webpack_public_path__ + "img/invoices.d7f10cb1.png";